import { createApp } from 'vue/dist/vue.esm-bundler.js'

{
  const appConfig = {
    data(){
      return {
        loading: false,
        search: '',
        attendees: []
      }
    },
    mounted(){
      this.loading = true
      window.coolHelperFunctions.coolAjax({ action: 'collect_banquet_registrants' }, json => {
        this.loading = false
        if(json?.data?.message){
          alert(json.data.message)
        } else {
          if(json?.data?.attendees){
            this.attendees = json.data.attendees
          } else {
            alert("Something went wrong. Please try again later.")
          }
        }
      }, err => alert(`Something went wrong. Please try again later. ${err}`))
    },
    computed: {
      foundAttendees(){ 
        let cleanSearch = this.search.trim().toLowerCase()
        return this.attendees.filter(a => {
          let cleanName = `${a.first_name.trim()} ${a.last_name.trim()}`.toLowerCase()
          return cleanName.indexOf(cleanSearch) !== -1
        })
      }
    },
    methods: {
      hasAssociatedAttendees(attendee){
        return this.getAssociatedAttendees(attendee).length
      },
      getAssociatedAttendees(attendee){
        return this.attendees.filter(a => a.registration_order_id == attendee.registration_order_id && a.id != attendee.id)
      },
      maybeDoubleCheckOrSend(attendee, event){
        if(attendee.attended){
          if(confirm(`Are you sure you want to mark ${attendee.first_name} ${attendee.last_name} as not attended?`)){
            this.sendAttendanceChange(attendee)
          } else {
            event.preventDefault()
          }
        } else {
          this.sendAttendanceChange(attendee)
        }
      },
      sendAttendanceChange(attendee){
        this.loading = true
        window.coolHelperFunctions.coolAjax({ action: 'submit_checkin_change', attendee: attendee }, json => {
          this.loading = false
          if(!json?.success){
            alert("Something went wrong. Please refresh the page and try again. Unsuccessful response")
          }
        }, err => alert(`Something went wrong. Please refresh the page and try again. ${err}`))        
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.banquet-check-in')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}